import React, { useState, useEffect, useRef, useCallback } from "react";
import icon from "../../images/icon.png";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  setDoc,
  deleteDoc,
  getDoc,
} from "firebase/firestore";
const MorseTrainerApp = () => {
  // Firebase Configuration - REPLACE WITH YOUR CONFIG
  const firebaseConfig = {
    apiKey: "AIzaSyBB6ieMgOJiY4Yd9X7JqiXDUj-4UPIju28",
    authDomain: "morsetrainer-a264b.firebaseapp.com",
    projectId: "morsetrainer-a264b",
    storageBucket: "morsetrainer-a264b.firebasestorage.app",
    messagingSenderId: "335408561412",
    appId: "1:335408561412:web:99f9f0e2a3146ca1a62451",
  };

  // Initialize Firebase
  const [db, setDb] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [firebaseInitialized, setFirebaseInitialized] = useState(false);

  useEffect(() => {
    try {
      const app = initializeApp(firebaseConfig);
      const firestore = getFirestore(app);
      setDb(firestore);
      setFirebaseInitialized(true);
    } catch (error) {
      console.error("Firebase initialization error:", error);
    }
  }, []);

  const wordList = [
    "CQ",
    "5NN",
    "EA1",
    "EA2",
    "EA7",
    "G4N",
    "5KOUA",
    "73",
    "QRT",
    "QSB",
    "DL4",
    "F6J",
    "QSO",
    "GRACIAS",
    "THANKS",
    "GOOD",
    "DX",
    "BUENOS",
    "BTU",
    "CALL",
    "ISLA",
  ];

  const morseDict = {
    A: ".-",
    B: "-...",
    C: "-.-.",
    D: "-..",
    E: ".",
    F: "..-.",
    G: "--.",
    H: "....",
    I: "..",
    J: ".---",
    K: "-.-",
    L: ".-..",
    M: "--",
    N: "-.",
    O: "---",
    P: ".--.",
    Q: "--.-",
    R: ".-.",
    S: "...",
    T: "-",
    U: "..-",
    V: "...-",
    W: ".--",
    X: "-..-",
    Y: "-.--",
    Z: "--..",
    1: ".----",
    2: "..---",
    3: "...--",
    4: "....-",
    5: ".....",
    6: "-....",
    7: "--...",
    8: "---..",
    9: "----.",
    0: "-----",
  };

  const translations = {
    en: {
      lang: "Language:",
      title: "Morse Trainer K5NN+",
      enterPassword: "🔐 User Password",
      unlock: "Unlock",
      pleaseEnterPassword: "Please enter password",
      passwordValid: "Password valid! Unlocking...",
      wrongPassword: "Wrong password!",
      time: "Time:",
      start: "Start",
      stop: "Stop",
      hits: "Hits",
      misses: "Misses",
      loadList: "Load List",
      clear: "Clear",
      debugInfo: "Debug Info",
      classic: "Classic",
      reverse: "Reverse",
      word: "Word",
      sentence: "Phrase",
      version: "v2.0 - Firebase Edition",
      enterSentences: "Enter sentences (one per line)",
      correct: "✓ CORRECT!",
      wrong: "✗ WRONG!",
      stopped: "Stopped",
      completed: "✓ Completed!",
      noList: "Please load a list first!",
      loaded: "Loaded",
      items: "items",
      loadingPasswords: "Loading passwords...",
      firebaseError: "Firebase connection error",
    },
    es: {
      lang: "Idioma:",
      title: "Entrenador Morse K5NN+",
      enterPassword: "🔐 Contraseña de Usuario",
      unlock: "Desbloquear",
      pleaseEnterPassword: "Por favor ingrese la contraseña",
      passwordValid: "¡Contraseña válida! Desbloqueando...",
      wrongPassword: "¡Contraseña incorrecta!",
      time: "Tiempo:",
      start: "Iniciar",
      stop: "Detener",
      hits: "Aciertos",
      misses: "Fallos",
      loadList: "Cargar Lista",
      clear: "Limpiar",
      debugInfo: "Info de Depuración",
      classic: "Clásico",
      reverse: "Invertido",
      word: "Palabra",
      sentence: "Frase",
      version: "v2.0 - Edición Firebase",
      enterSentences: "Ingrese oraciones (una por línea)",
      correct: "✓ ¡CORRECTO!",
      wrong: "✗ ¡INCORRECTO!",
      stopped: "Detenido",
      completed: "✓ ¡Completado!",
      noList: "¡Por favor cargue una lista primero!",
      loaded: "Cargado",
      items: "elementos",
      loadingPasswords: "Cargando contraseñas...",
      firebaseError: "Error de conexión Firebase",
    },
    it: {
      lang: "lingua:",
      title: "Allenatore Morse K5NN+",
      enterPassword: "🔐 Inserisci Password",
      unlock: "Sblocca",
      pleaseEnterPassword: "Si prega di inserire la password",
      passwordValid: "Password valida! Sbloccando...",
      wrongPassword: "Password errata!",
      time: "Tempo:",
      start: "Avvia",
      stop: "Ferma",
      hits: "Corretti",
      misses: "Errori",
      loadList: "Carica Lista",
      clear: "Cancella",
      debugInfo: "Info Debug",
      classic: "Classico",
      reverse: "Inverso",
      word: "Parola",
      sentence: "Frase",
      version: "v2.0 - Edizione Firebase",
      enterSentences: "Inserisci frasi (una per riga)",
      correct: "✓ CORRETTO!",
      wrong: "✗ SBAGLIATO!",
      stopped: "Fermato",
      completed: "✓ Completato!",
      noList: "Si prega di caricare prima un elenco!",
      loaded: "Caricato",
      items: "elementi",
      loadingPasswords: "Caricamento password...",
      firebaseError: "Errore di connessione Firebase",
    },
  };

  // State
  const [isLocked, setIsLocked] = useState(true);
  const [showAdminOverlay, setShowAdminOverlay] = useState(false);
  const [showAdminPanel, setShowAdminPanel] = useState(false);
  const [licenseInput, setLicenseInput] = useState("");
  const [adminInput, setAdminInput] = useState("");
  const [licenseMsg, setLicenseMsg] = useState("");
  const [licenseMsgType, setLicenseMsgType] = useState("");
  const [adminMsg, setAdminMsg] = useState("");
  const [adminMsgType, setAdminMsgType] = useState("");
  const [currentLang, setCurrentLang] = useState("en");
  const [mode, setMode] = useState("classic");
  const [listItems, setListItems] = useState([]);
  const [correct, setCorrect] = useState(0);
  const [wrong, setWrong] = useState(0);
  const [gameIsRunning, setGameIsRunning] = useState(false);
  const [currentLetter, setCurrentLetter] = useState("?");
  const [currentMorseCode, setCurrentMorseCode] = useState("");
  const [inputMorse, setInputMorse] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentLetterIndex, setCurrentLetterIndex] = useState(0);
  const [currentWord, setCurrentWord] = useState("");
  const [timerProgress, setTimerProgress] = useState(100);
  const [message, setMessage] = useState("");
  const [output, setOutput] = useState("");
  const [debugText, setDebugText] = useState("");
  const [sentenceDisplay, setSentenceDisplay] = useState("");
  const [timeSelect, setTimeSelect] = useState("5");
  const [listInput, setListInput] = useState("");
  const [allowedHashes, setAllowedHashes] = useState([]);
  const [userPasswords, setUserPasswords] = useState([]);
  const [newPasswordInput, setNewPasswordInput] = useState("");
  const [isLoadingPasswords, setIsLoadingPasswords] = useState(false);
  const [adminPasswordHash, setAdminPasswordHash] = useState("");

  // Refs
  const timerRef = useRef(null);
  const audioCtxRef = useRef(null);
  const gameIsRunningRef = useRef(false);
  const isHoldingRef = useRef(false);
  const holdStartRef = useRef(0);
  const analyserRef = useRef(null);
  const dataArrayRef = useRef(null);
  const micRmsThreshold = 12;
  const isSoundingRef = useRef(false);
  const soundStartRef = useRef(0);
  const suppressMicWhilePlayingRef = useRef(false);
  const animationFrameRef = useRef(null);

  useEffect(() => {
    gameIsRunningRef.current = gameIsRunning;
  }, [gameIsRunning]);

  // Load passwords from Firebase
  const loadPasswordsFromFirebase = async () => {
    if (!db) return;

    setIsLoadingPasswords(true);
    try {
      const passwordsSnapshot = await getDocs(collection(db, "userPasswords"));
      const passwords = [];
      passwordsSnapshot.forEach((doc) => {
        passwords.push(doc.data().password);
      });
      setUserPasswords(passwords);

      // Generate hashes for all passwords
      const hashes = [];
      for (const p of passwords) {
        const buf = await crypto.subtle.digest(
          "SHA-256",
          new TextEncoder().encode(p)
        );
        hashes.push(
          Array.from(new Uint8Array(buf))
            .map((x) => x.toString(16).padStart(2, "0"))
            .join("")
        );
      }
      setAllowedHashes(hashes);

      setDebugText(`Loaded ${passwords.length} passwords from Firebase`);
    } catch (error) {
      console.error("Error loading passwords:", error);
      setDebugText(`Error loading passwords: ${error.message}`);
    } finally {
      setIsLoadingPasswords(false);
    }
  };

  // Load admin password from Firebase
  const loadAdminPassword = async () => {
    if (!db) return;

    try {
      const adminDoc = await getDoc(doc(db, "config", "adminPassword"));
      if (adminDoc.exists()) {
        const adminPass = adminDoc.data().password;
        const buf = await crypto.subtle.digest(
          "SHA-256",
          new TextEncoder().encode(adminPass)
        );
        const hash = Array.from(new Uint8Array(buf))
          .map((x) => x.toString(16).padStart(2, "0"))
          .join("");
        setAdminPasswordHash(hash);
      }
    } catch (error) {
      console.error("Error loading admin password:", error);
    }
  };

  useEffect(() => {
    if (firebaseInitialized && db) {
      loadPasswordsFromFirebase();
      loadAdminPassword();
    }
  }, [firebaseInitialized, db]);

  const t = translations[currentLang];

  const checkLicense = async () => {
    const val = licenseInput.trim();

    if (!val) {
      setLicenseMsg(t.pleaseEnterPassword);
      setLicenseMsgType("error");
      return;
    }

    if (!firebaseInitialized) {
      setLicenseMsg(t.firebaseError);
      setLicenseMsgType("error");
      return;
    }

    const buf = await crypto.subtle.digest(
      "SHA-256",
      new TextEncoder().encode(val)
    );
    const h = Array.from(new Uint8Array(buf))
      .map((x) => x.toString(16).padStart(2, "0"))
      .join("");

    if (allowedHashes.includes(h)) {
      setLicenseMsg(t.passwordValid);
      setLicenseMsgType("success");
      setTimeout(() => setIsLocked(false), 800);
    } else {
      setLicenseMsg(t.wrongPassword);
      setLicenseMsgType("error");
    }
  };

  const checkAdminPassword = async () => {
    const val = adminInput.trim();

    if (!val) {
      setAdminMsg("Please enter valid password");
      setAdminMsgType("error");
      return;
    }

    if (!firebaseInitialized) {
      setAdminMsg(t.firebaseError);
      setAdminMsgType("error");
      return;
    }

    const buf = await crypto.subtle.digest(
      "SHA-256",
      new TextEncoder().encode(val)
    );
    const h = Array.from(new Uint8Array(buf))
      .map((x) => x.toString(16).padStart(2, "0"))
      .join("");
    // DEBUG - Add these lines
    console.log("Input password:", val);
    console.log("Input hash:", h);
    console.log("Stored admin hash:", adminPasswordHash);
    console.log("Match:", h === adminPasswordHash);
    if (h === adminPasswordHash) {
      setAdminMsg("Admin access granted!");
      setAdminMsgType("success");
      setTimeout(() => {
        setShowAdminOverlay(false);
        setShowAdminPanel(true);
      }, 800);
    } else {
      setAdminMsg("Wrong admin password!");
      setAdminMsgType("error");
    }
  };

  const randomLetter = () => {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return letters[Math.floor(Math.random() * letters.length)];
  };

  const playMorse = useCallback((code) => {
    if (!code) return;
    if (!audioCtxRef.current) {
      audioCtxRef.current = new (window.AudioContext ||
        window.webkitAudioContext)();
    }

    suppressMicWhilePlayingRef.current = true; // Suppress mic

    const ctx = audioCtxRef.current;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = 600;
    gain.gain.value = 0;
    osc.connect(gain);
    gain.connect(ctx.destination);

    const unit = 0.1;
    const gap = 0.08;

    let time = ctx.currentTime + 0.02;
    for (const c of code) {
      if (c === ".") {
        gain.gain.setValueAtTime(1, time);
        gain.gain.setValueAtTime(0, time + unit);
        time += unit + gap;
      } else {
        gain.gain.setValueAtTime(1, time);
        gain.gain.setValueAtTime(0, time + unit * 3);
        time += unit * 3 + gap;
      }
    }
    osc.start(ctx.currentTime + 0.01);
    osc.stop(time + 0.02);

    // Re-enable mic after playback
    setTimeout(() => {
      suppressMicWhilePlayingRef.current = false;
    }, (time - ctx.currentTime + 0.05) * 1000);
  }, []);
  const playInputSound = useCallback((key) => {
    if (!audioCtxRef.current) {
      audioCtxRef.current = new (window.AudioContext ||
        window.webkitAudioContext)();
    }

    const ctx = audioCtxRef.current;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = 600;
    gain.gain.value = 0;
    osc.connect(gain);
    gain.connect(ctx.destination);

    const unit = 0.1;
    const time = ctx.currentTime;

    if (key === ".") {
      // Short beep for dot
      gain.gain.setValueAtTime(0.5, time);
      gain.gain.setValueAtTime(0, time + unit);
      osc.start(time);
      osc.stop(time + unit + 0.01);
    } else if (key === "-") {
      // Long beep for dash
      gain.gain.setValueAtTime(0.5, time);
      gain.gain.setValueAtTime(0, time + unit * 3);
      osc.start(time);
      osc.stop(time + unit * 3 + 0.01);
    }
  }, []);
  const setupAudio = useCallback(async () => {
    if (analyserRef.current) return;

    try {
      if (!audioCtxRef.current) {
        audioCtxRef.current = new (window.AudioContext ||
          window.webkitAudioContext)();
      }

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const micStream = audioCtxRef.current.createMediaStreamSource(stream);
      analyserRef.current = audioCtxRef.current.createAnalyser();
      analyserRef.current.fftSize = 2048;
      micStream.connect(analyserRef.current);
      dataArrayRef.current = new Uint8Array(analyserRef.current.fftSize);
      listenLoop();
    } catch (err) {
      console.error("Microphone error:", err);
      alert("Please allow microphone access for sound detection!");
    }
  }, []);

  const listenLoop = useCallback(() => {
    if (!analyserRef.current || !dataArrayRef.current) return;

    analyserRef.current.getByteTimeDomainData(dataArrayRef.current);

    let sum = 0;
    for (let i = 0; i < dataArrayRef.current.length; i++) {
      const v = dataArrayRef.current[i] - 128;
      sum += v * v;
    }
    const rms = Math.sqrt(sum / dataArrayRef.current.length);
    const now = performance.now();

    // Skip mic detection while playing morse code
    if (suppressMicWhilePlayingRef.current) {
      animationFrameRef.current = requestAnimationFrame(listenLoop);
      return;
    }

    if (rms > micRmsThreshold) {
      if (!isSoundingRef.current) {
        isSoundingRef.current = true;
        soundStartRef.current = now;
      }
    } else {
      if (isSoundingRef.current) {
        const duration = now - soundStartRef.current;
        const symbol = duration < 200 ? "." : "-";

        setInputMorse((prev) => prev + symbol);
        setOutput((prev) => prev + symbol);
        setDebugText((prev) => prev + symbol);

        isSoundingRef.current = false;
      }
    }

    animationFrameRef.current = requestAnimationFrame(listenLoop);
  }, []);
  const nextLetter = useCallback(() => {
    if (timerRef.current) clearInterval(timerRef.current);

    if (mode === "word" || mode === "sentence") {
      setCurrentLetterIndex((prev) => {
        const newIdx = prev + 1;
        if (newIdx >= currentWord.length) {
          setCurrentIndex((prevIdx) => {
            const newWordIdx = prevIdx + 1;
            if (newWordIdx >= listItems.length) {
              setGameIsRunning(false);
              setMessage(t.completed);
              return prevIdx;
            }
            const newWord = listItems[newWordIdx].toUpperCase();
            setCurrentWord(newWord);
            setSentenceDisplay(newWord);
            setCurrentLetter(newWord[0]);
            setCurrentMorseCode(morseDict[newWord[0]] || "");
            playMorse(morseDict[newWord[0]] || "");
            return newWordIdx;
          });
          return 0;
        } else {
          const newLetter = currentWord[newIdx];
          setCurrentLetter(newLetter);
          setCurrentMorseCode(morseDict[newLetter] || "");
          playMorse(morseDict[newLetter] || "");
          return newIdx;
        }
      });
    } else {
      const newLetter = randomLetter();
      setCurrentLetter(newLetter);
      setCurrentMorseCode(morseDict[newLetter] || "");
      playMorse(morseDict[newLetter] || "");
    }

    startTimer();
  }, [mode, currentWord, listItems, t, playMorse]);

  // Combined keyboard handler - supports both Space hold AND . - keys
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!gameIsRunning) return;

      // Space key hold for Morse keyboard
      if (e.code === "Space" && !isHoldingRef.current) {
        e.preventDefault();
        isHoldingRef.current = true;
        holdStartRef.current = Date.now();
      }
    };

    const handleKeyUp = (e) => {
      if (!gameIsRunning) return;

      // Space key release - determine dot or dash by duration
      if (e.code === "Space" && isHoldingRef.current) {
        e.preventDefault();
        isHoldingRef.current = false;
        const duration = Date.now() - holdStartRef.current;
        const symbol = duration < 200 ? "." : "-";

        setInputMorse((prev) => prev + symbol);
        setOutput((prev) => prev + symbol);
        playInputSound(symbol);
        setDebugText((prev) => prev + symbol);
      }
    };

    const handleKeyPress = (e) => {
      if (!gameIsRunning) return;

      // Direct . and - key presses for regular keyboard
      if (e.key === "." || e.key === "-") {
        e.preventDefault();
        setInputMorse((prev) => prev + e.key);
        setOutput((prev) => prev + e.key);
        playInputSound(e.key);
        setDebugText((prev) => prev + e.key);
      } else if (e.key === "Backspace") {
        e.preventDefault();
        setInputMorse((prev) => prev.slice(0, -1));
        setOutput((prev) => prev.slice(0, -1));
        setDebugText((prev) => prev.slice(0, -1));
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);
    window.addEventListener("keypress", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, [gameIsRunning, playInputSound]);

  const inputMorseRef = useRef("");
  const currentMorseCodeRef = useRef("");

  // Update refs when state changes
  useEffect(() => {
    inputMorseRef.current = inputMorse;
  }, [inputMorse]);

  useEffect(() => {
    currentMorseCodeRef.current = currentMorseCode;
  }, [currentMorseCode]);

  const startTimer = useCallback(() => {
    if (timerRef.current) clearInterval(timerRef.current);
    const duration = parseFloat(timeSelect) * 1000;
    const startTime = Date.now();

    timerRef.current = setInterval(() => {
      if (!gameIsRunningRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
        return;
      }

      const elapsed = Date.now() - startTime;
      const prog = Math.min(elapsed / duration, 1);
      setTimerProgress((1 - prog) * 100);

      if (elapsed >= duration) {
        clearInterval(timerRef.current);
        timerRef.current = null;

        if (!gameIsRunningRef.current) return;

        // Use refs to get current values - prevents double counting
        const userInput = inputMorseRef.current.trim();
        const correctCode = currentMorseCodeRef.current.trim();

        if (userInput === correctCode) {
          setCorrect((prev) => prev + 1);
          setMessage(t.correct);
        } else {
          setWrong((prev) => prev + 1);
          setMessage(`${t.wrong} (${userInput || "empty"} ≠ ${correctCode})`);
        }

        setInputMorse("");
        setOutput("");

        setTimeout(() => {
          if (gameIsRunningRef.current) {
            nextLetter();
          }
        }, 800);
      }
    }, 60);
  }, [timeSelect, t, nextLetter]);
  const startGame = () => {
    if (gameIsRunning) return;

    if (mode === "word" || mode === "sentence") {
      if (!listItems || listItems.length === 0) {
        alert(t.noList);
        return;
      }
    }

    setGameIsRunning(true);
    setCorrect(0);
    setWrong(0);
    setCurrentIndex(0);
    setCurrentLetterIndex(0);
    setInputMorse("");
    setOutput("");
    setMessage("");

    let letter = "";
    let word = "";

    if (mode === "word" || mode === "sentence") {
      word = listItems[0].toUpperCase();
      setCurrentWord(word);
      letter = word[0];
      setSentenceDisplay(word);
    } else {
      letter = randomLetter();
    }

    setCurrentLetter(letter);
    const morse = morseDict[letter] || "";
    setCurrentMorseCode(morse);
    playMorse(morse);
    startTimer();
    setupAudio(); // Initialize microphone
  };

  const stopGame = () => {
    setGameIsRunning(false);
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    setInputMorse("");
    setOutput("");
    setMessage(t.stopped);
    setTimerProgress(100);
  };

  const changeMode = (newMode) => {
    if (gameIsRunning) {
      setGameIsRunning(false);
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    }

    setMode(newMode);
    setInputMorse("");
    setOutput("");
    setDebugText("");
    setSentenceDisplay("");
    setMessage("");
    setCurrentLetter("?");
    setTimerProgress(100);

    if (newMode === "word") {
      setListItems([...wordList]);
      setListInput(wordList.join("\n"));
    } else if (newMode === "sentence") {
      setListInput("");
      setListItems([]);
    } else {
      setListInput("");
      setListItems([]);
    }
  };

  const loadList = () => {
    const txt = listInput.trim();
    if (!txt) {
      alert(t.noList);
      return;
    }
    const items = txt
      .split(/\n/)
      .map((x) => x.trim())
      .filter(Boolean);
    setListItems(items);
    alert(`${t.loaded} ${items.length} ${t.items}.`);
  };

  const handleAddPassword = async () => {
    const newPass = newPasswordInput.trim();
    if (!newPass) return;

    if (!db) {
      alert(t.firebaseError);
      return;
    }

    try {
      // Add to Firebase
      await setDoc(doc(db, "userPasswords", newPass), {
        password: newPass,
        createdAt: new Date().toISOString(),
      });

      // Reload passwords
      await loadPasswordsFromFirebase();
      setNewPasswordInput("");
      alert("Password added successfully!");
    } catch (error) {
      console.error("Error adding password:", error);
      alert("Error adding password: " + error.message);
    }
  };

  const handleRemovePassword = async (pass) => {
    if (!db) {
      alert(t.firebaseError);
      return;
    }

    setConfirmDelete(pass);
  };

  const confirmDeletePassword = async () => {
    const pass = confirmDelete;
    setConfirmDelete(null);

    try {
      // Remove from Firebase
      await deleteDoc(doc(db, "userPasswords", pass));

      // Reload passwords
      await loadPasswordsFromFirebase();
      alert("Password removed successfully!");
    } catch (error) {
      console.error("Error removing password:", error);
      alert("Error removing password: " + error.message);
    }
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
      if (animationFrameRef.current)
        cancelAnimationFrame(animationFrameRef.current);
    };
  }, []);

  const styles = {
    messageSuccess: {
      color: "#19c37d",
      fontWeight: "600",
    },
    messageError: {
      color: "#ff4d6d",
      fontWeight: "600",
    },
  };

  return (
    <div className="app-container">
      <style>{`
        * {
          box-sizing: border-box;
        }
        
        .app-container {
          font-family: 'Inter', 'Segoe UI', system-ui, sans-serif;
          background: linear-gradient(180deg, #0b0c0d 0%, #111214 100%);
          color: #e6f7f5;
          min-height: 100vh;
          margin: 0;
          padding: 0;
        }

        .overlay {
          position: fixed;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(0, 0, 0, 0.95);
          z-index: 9999;
          padding: 1rem;
        }

        .modal {
          background: #111;
          padding: 2rem;
          border-radius: 10px;
          text-align: center;
          color: #fff;
          max-width: 420px;
          width: 100%;
          border: 2px solid #00ffea;
        }

        .modal h2 {
          color: #00ffea;
          margin-bottom: 1.5rem;
          font-size: 1.5rem;
        }

        .modal input {
          width: 100%;
          padding: 12px;
          border-radius: 6px;
          border: 2px solid #00ffea;
          margin-bottom: 12px;
          font-size: 1rem;
          background: #0f1113;
          color: #e6f7f5;
        }

        .btn-primary {
          width: 100%;
          padding: 12px;
          background: #00ffea;
          color: #061018;
          border: none;
          border-radius: 6px;
          font-weight: 700;
          cursor: pointer;
          font-size: 1rem;
          transition: opacity 0.2s;
        }

        .btn-primary:hover {
          opacity: 0.9;
        }

        .btn-primary:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .btn-secondary {
          width: 100%;
          padding: 12px;
          background: #333;
          color: #fff;
          border: none;
          border-radius: 6px;
          font-weight: 700;
          cursor: pointer;
          font-size: 1rem;
          margin-top: 8px;
        }

        .message-box {
          margin-top: 12px;
          min-height: 1.2em;
          font-weight: 600;
        }

        .navbar {
          background: linear-gradient(135deg, #0d1518 0%, #1a1f24 100%);
          padding: 1rem 2rem;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
          border-bottom: 2px solid rgba(0, 255, 234, 0.2);
        }

        .nav-content {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 1rem;
          flex-wrap: wrap;
        }

        .logo-section {
          display: flex;
          align-items: center;
          gap: 1rem;
          text-decoration: none;
          color: inherit;
        }

        .logo {
          width: 50px;
          height: 50px;
          background: linear-gradient(135deg, #00ffea, #7effd6);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          font-weight: 700;
          color: #061018;
          box-shadow: 0 4px 15px rgba(0, 255, 234, 0.3);
        }

        .nav-title {
          margin: 0;
          font-size: 1.5rem;
          color: #00ffea;
          font-weight: 700;
        }

        .nav-subtitle {
          font-size: 0.85rem;
          color: #9aa3a8;
          margin-top: 2px;
        }

        .nav-controls {
          display: flex;
          align-items: center;
          gap: 1rem;
          flex-wrap: wrap;
        }

        .main-content {
          max-width: 1200px;
          margin: 0 auto;
          padding: 1.5rem;
        }

        .mode-controls {
          background: #101316;
          padding: 1rem;
          border-radius: 10px;
          margin-bottom: 1rem;
          display: flex;
          gap: 0.5rem;
          flex-wrap: wrap;
        }

        .mode-btn {
          background: #0b0f10;
          border: 1px solid rgba(255, 255, 255, 0.03);
          color: #00ffea;
          padding: 8px 12px;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 600;
          transition: all 0.3s;
          font-size: 0.9rem;
        }

        .mode-btn.active {
          background: #00ffea;
          color: #061018;
          font-weight: 700;
        }

        .main-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 1rem;
          width: 100%;
        }

        @media (min-width: 1024px) {
          .main-grid {
            grid-template-columns: 1fr 360px;
          }
        }

        .game-panel, .list-panel {
          background: #101316;
          padding: 1rem;
          border-radius: 10px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
        }

        .game-controls {
          display: flex;
          gap: 0.5rem;
          align-items: center;
          flex-wrap: wrap;
          margin-bottom: 1rem;
        }

        .timer-bar {
          width: 100%;
          background: #0b0b0b;
          border-radius: 8px;
          padding: 6px;
          margin-bottom: 1rem;
        }

        .timer-fill {
          height: 12px;
          background: linear-gradient(90deg, #00ffea, #7effd6);
          border-radius: 6px;
          transition: width 0.08s linear;
        }

        .letter-display {
          font-size: 4rem;
          color: #ffd94d;
          letter-spacing: 6px;
          margin: 1rem 0;
          text-align: center;
        }

        @media (min-width: 768px) {
          .letter-display {
            font-size: 5.25rem;
          }
        }

        .output-display {
          font-size: 1.8rem;
          letter-spacing: 6px;
          color: #00ffea;
          min-height: 42px;
          text-align: center;
        }

        .stats {
          font-size: 0.95rem;
          color: #9aa3a8;
          text-align: center;
        }

        textarea {
          width: 100%;
          height: 120px;
          background: #070808;
          border-radius: 8px;
          border: 1px solid rgba(255, 255, 255, 0.03);
          padding: 8px;
          color: #dff;
          font-family: inherit;
          resize: none;
        }

        select {
          padding: 8px 10px;
          border-radius: 8px;
          border: 2px solid rgba(0, 255, 234, 0.3);
          background: #0d1518;
          color: #00ffea;
          font-weight: 600;
          cursor: pointer;}

        .admin-panel {
          min-height: 100vh;
          background: #0b0f10;
        }

        .admin-nav {
          background: #0f1a1c;
          border-bottom: 2px solid rgba(0, 255, 234, 0.15);
          padding: 1rem 2rem;
        }

        .admin-content {
          padding: 2rem;
        }

        .password-card {
          background: #0c1315;
          border-radius: 10px;
          padding: 2rem;
          max-width: 800px;
          margin: 2rem auto;
          box-shadow: 0 0 20px rgba(0, 255, 234, 0.05);
        }

        .password-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px;
          background: #101316;
          border-radius: 8px;
          margin-bottom: 0.5rem;
          border-left: 3px solid #00ffea;
        }

        .btn-danger {
          padding: 6px 16px;
          background: #ff4d6d;
          color: white;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 600;
          font-size: 0.9rem;
        }

        .btn-success {
          padding: 12px 24px;
          background: #19c37d;
          color: white;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 700;
          font-size: 1rem;
        }

        @media (max-width: 768px) {
          .navbar {
            padding: 1rem;
          }
          
          .nav-content {
            flex-direction: column;
            align-items: flex-start;
          }
          
          .nav-title {
            font-size: 1.2rem;
          }
          
          .main-content {
            padding: 1rem;
          }
          
          .letter-display {
            font-size: 3rem;
          }
          
          .output-display {
            font-size: 1.4rem;
          }
        }
      `}</style>

      {/* Lock Overlay */}
      {isLocked && !showAdminOverlay && !showAdminPanel && (
        <div className="overlay">
          <div className="modal">
            <h2>{t.enterPassword}</h2>
            {isLoadingPasswords && (
              <div style={{ color: "#00ffea", marginBottom: "1rem" }}>
                {t.loadingPasswords}
              </div>
            )}
            <input
              type="password"
              placeholder="Enter password"
              value={licenseInput}
              onChange={(e) => setLicenseInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && checkLicense()}
              disabled={isLoadingPasswords}
            />
            <button
              onClick={checkLicense}
              className="btn-primary"
              disabled={isLoadingPasswords}
            >
              {t.unlock}
            </button>
            <div
              className="message-box"
              style={
                licenseMsgType === "success"
                  ? styles.messageSuccess
                  : licenseMsgType === "error"
                  ? styles.messageError
                  : {}
              }
            >
              {licenseMsg}
            </div>
            <div style={{ marginTop: "20px" }}>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setIsLocked(false);
                  setShowAdminOverlay(true);
                }}
                style={{
                  color: "#00ffea",
                  textDecoration: "none",
                  fontSize: "0.9rem",
                }}
              >
                Your Admin?
              </a>
            </div>
          </div>
        </div>
      )}

      {/* Admin Overlay */}
      {showAdminOverlay && (
        <div className="overlay">
          <div className="modal">
            <h2>🔑 Admin Access</h2>
            <input
              type="password"
              placeholder="Enter admin password"
              value={adminInput}
              onChange={(e) => setAdminInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && checkAdminPassword()}
            />
            <button onClick={checkAdminPassword} className="btn-primary">
              Enter Admin
            </button>
            <button
              onClick={() => {
                setShowAdminOverlay(false);
                setIsLocked(true);
              }}
              className="btn-secondary"
            >
              Back to User Login
            </button>
            <div
              className="message-box"
              style={
                adminMsgType === "success"
                  ? styles.messageSuccess
                  : adminMsgType === "error"
                  ? styles.messageError
                  : {}
              }
            >
              {adminMsg}
            </div>
          </div>
        </div>
      )}

      {/* Admin Panel */}
      {showAdminPanel && (
        <div className="admin-panel">
          <nav className="admin-nav">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "1rem",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
              >
                <div>
                  <img className="logo" src={icon} alt="logo" />
                </div>
                <div>
                  <h1
                    style={{ color: "#00ffea", margin: 0, fontSize: "1.5rem" }}
                  >
                    Admin Panel
                  </h1>
                  <span style={{ color: "#9fffea", fontSize: "0.9rem" }}>
                    Firebase Password Management
                  </span>
                </div>
              </div>
              <button
                onClick={() => {
                  setShowAdminPanel(false);
                  setIsLocked(true);
                  setAdminInput("");
                  setAdminMsg("");
                }}
                className="btn-danger"
              >
                Logout
              </button>
            </div>
          </nav>
          <div className="admin-content">
            <div className="password-card">
              <h2
                style={{
                  color: "#00ffea",
                  marginBottom: "1.5rem",
                  textAlign: "center",
                }}
              >
                Manage User Passwords
              </h2>
              <div
                style={{
                  background: "#0d1518",
                  padding: "1.5rem",
                  borderRadius: "10px",
                  marginBottom: "2rem",
                  border: "2px solid rgba(0, 255, 234, 0.2)",
                }}
              >
                <h3
                  style={{
                    color: "#00ffea",
                    marginBottom: "1rem",
                    fontSize: "1.1rem",
                  }}
                >
                  Add New Password
                </h3>
                <div
                  style={{
                    display: "flex",
                    gap: "0.5rem",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <input
                    type="text"
                    placeholder="Enter new password"
                    value={newPasswordInput}
                    onChange={(e) => setNewPasswordInput(e.target.value)}
                    style={{
                      flex: 1,
                      minWidth: "200px",
                      padding: "12px",
                      borderRadius: "8px",
                      border: "2px solid rgba(0, 255, 234, 0.3)",
                      background: "#0f1113",
                      color: "#e6f7f5",
                      fontSize: "1rem",
                    }}
                  />
                  <button onClick={handleAddPassword} className="btn-success">
                    Add
                  </button>
                </div>
              </div>
              <div
                style={{
                  background: "#0d1518",
                  padding: "1.5rem",
                  borderRadius: "10px",
                  border: "2px solid rgba(255, 77, 109, 0.2)",
                }}
              >
                <h3
                  style={{
                    color: "#ff4d6d",
                    marginBottom: "1rem",
                    fontSize: "1.1rem",
                  }}
                >
                  Current Passwords (Firebase)
                </h3>
                {isLoadingPasswords ? (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "2rem",
                      color: "#00ffea",
                    }}
                  >
                    Loading password...
                  </div>
                ) : (
                  <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                    {userPasswords.length === 0 ? (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "2rem",
                          color: "#9aa3a8",
                        }}
                      >
                        No passwords found. Add some passwords above.
                      </div>
                    ) : (
                      userPasswords.map((pass, idx) => (
                        <div key={idx} className="password-item">
                          <span
                            style={{
                              fontFamily: "monospace",
                              fontSize: "1rem",
                            }}
                          >
                            {pass}
                          </span>
                          <button
                            onClick={() => handleRemovePassword(pass)}
                            className="btn-danger"
                          >
                            Remove
                          </button>
                        </div>
                      ))
                    )}
                  </div>
                )}
                <div
                  style={{
                    marginTop: "1rem",
                    padding: "12px",
                    background: "rgba(0, 255, 234, 0.1)",
                    borderRadius: "8px",
                    border: "1px solid rgba(0, 255, 234, 0.2)",
                  }}
                >
                  <p
                    style={{ color: "#00ffea", margin: 0, fontSize: "0.95rem" }}
                  >
                    <strong>Total Passwords:</strong> {userPasswords.length}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {confirmDelete && (
            <div className="overlay">
              <div className="modal">
                <h2 style={{ color: "#ff4d6d" }}>⚠️ Confirm Delete</h2>
                <p style={{ marginBottom: "1.5rem" }}>
                  Are you sure you want to remove password: <br />
                  <strong style={{ color: "#00ffea" }}>{confirmDelete}</strong>?
                </p>
                <button
                  onClick={confirmDeletePassword}
                  className="btn-danger"
                  style={{ width: "100%", marginBottom: "0.5rem" }}
                >
                  Yes, Remove It
                </button>
                <button
                  onClick={() => setConfirmDelete(null)}
                  className="btn-secondary"
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Main App */}
      {!isLocked && !showAdminPanel && (
        <div>
          <nav className="navbar">
            <div className="nav-content">
              <a href="#" className="logo-section">
                <div>
                  <img className="logo" src={icon} alt="logo" />
                </div>
                <div>
                  <h1 className="nav-title">{t.title}</h1>
                  <span className="nav-subtitle">{t.version}</span>
                </div>
              </a>
              <div className="nav-controls">
                <a
                  href="https://www.kl73.es"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#00ffea",
                    textDecoration: "none",
                    fontSize: "0.95rem",
                    fontWeight: "600",
                  }}
                >
                  www.kl73.es
                </a>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <label style={{ color: "#9aa3a8", fontSize: "0.9rem" }}>
                    {t.lang}
                  </label>
                  <select
                    value={currentLang}
                    onChange={(e) => setCurrentLang(e.target.value)}
                  >
                    <option value="en">English</option>
                    <option value="es">Español</option>
                    <option value="it">Italiano</option>
                  </select>
                </div>
              </div>
            </div>
          </nav>

          <div className="main-content">
            <div className="mode-controls">
              <button
                onClick={() => changeMode("classic")}
                className={`mode-btn ${mode === "classic" ? "active" : ""}`}
              >
                {t.classic}
              </button>
              <button
                onClick={() => changeMode("reverse")}
                className={`mode-btn ${mode === "reverse" ? "active" : ""}`}
              >
                {t.reverse}
              </button>
              <button
                onClick={() => changeMode("word")}
                className={`mode-btn ${mode === "word" ? "active" : ""}`}
              >
                {t.word}
              </button>
              <button
                onClick={() => changeMode("sentence")}
                className={`mode-btn ${mode === "sentence" ? "active" : ""}`}
              >
                {t.sentence}
              </button>
            </div>

            <div className="main-grid">
              <div className="game-panel">
                <div className="game-controls">
                  <label style={{ fontSize: "0.9rem", color: "#9aa3a8" }}>
                    {t.time}
                  </label>
                  <select
                    value={timeSelect}
                    onChange={(e) => setTimeSelect(e.target.value)}
                  >
                    <option value="0.5">0.5s</option>
                    <option value="1">1s</option>
                    <option value="2">2s</option>
                    <option value="3">3s</option>
                    <option value="5">5s</option>
                    <option value="8">8s</option>
                    <option value="10">10s</option>
                  </select>
                  <button
                    onClick={gameIsRunning ? stopGame : startGame}
                    className="btn-primary"
                    style={{ width: "auto" }}
                  >
                    {gameIsRunning ? t.stop : t.start}
                  </button>
                </div>
                <div className="timer-bar">
                  <div
                    className="timer-fill"
                    style={{ width: `${timerProgress}%` }}
                  ></div>
                </div>

                <div style={{ textAlign: "center" }}>
                  <div className="letter-display">
                    {mode === "reverse" ? currentMorseCode : currentLetter}
                  </div>
                  {sentenceDisplay && (
                    <div
                      style={{
                        fontSize: "1.2rem",
                        marginTop: "0.4rem",
                        color: "#9aa3a8",
                      }}
                    >
                      {sentenceDisplay}
                    </div>
                  )}
                  <div className="output-display">{output}</div>
                  <div style={{ minHeight: "44px", margin: "1rem 0" }}>
                    {message}
                  </div>
                  <div className="stats">
                    {t.hits}: {correct} | {t.misses}: {wrong}
                  </div>
                </div>
              </div>

              <div className="list-panel">
                <textarea
                  value={listInput}
                  onChange={(e) => setListInput(e.target.value)}
                  placeholder={t.enterSentences}
                />
                <div
                  style={{
                    display: "flex",
                    gap: "0.5rem",
                    marginTop: "0.6rem",
                  }}
                >
                  <button
                    onClick={loadList}
                    className="btn-primary"
                    style={{ width: "auto" }}
                  >
                    {t.loadList}
                  </button>
                  <button
                    onClick={() => {
                      setListInput("");
                      setListItems([]);
                    }}
                    style={{
                      padding: "10px 12px",
                      borderRadius: "8px",
                      border: "none",
                      background: "#0d1518",
                      color: "#00ffea",
                      cursor: "pointer",
                    }}
                  >
                    {t.clear}
                  </button>
                </div>

                <hr
                  style={{
                    opacity: 0.06,
                    margin: "0.8rem 0",
                    border: "none",
                    borderTop: "1px solid rgba(255,255,255,0.1)",
                  }}
                />
                <div style={{ fontSize: "0.9rem", color: "#9aa3a8" }}>
                  {t.debugInfo}
                </div>
                <div
                  style={{
                    marginTop: "0.5rem",
                    color: "#9aa3a8",
                    fontSize: "0.9rem",
                  }}
                >
                  {/* {debugText} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MorseTrainerApp;
